import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import { can } from '@/ability'
import { Cast } from '@/modules/casts/classes'
import { isValidCasterInCast } from '@/modules/casts/utils/castCasters'
import store from '@/store'
import { computed, ComputedRef } from '@vue/composition-api'
import { CastLayoutView } from '../../utils/castlayouts'
import { MemberRole } from '@/modules/teams/types'

const getCurrentView = (cast: ComputedRef<Cast|null>): ComputedRef<CastLayoutView|null> => {
  return computed(() => {
    const userId = store.state.user.id
    const isStation = store.state.team.team?.members[userId ?? '']?.role === MemberRole.Station
    if (cast.value !== null && isValidCasterInCast(userId, cast.value)) {
      if (isStation) return CastLayoutView.Station
      return CastLayoutView.Caster
    }
    if (can.value(AbilityAction.Read, AbilitySubject.Cast)) {
      return CastLayoutView.Producer
    }
    return null
  })
}

export default getCurrentView
